import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCurrentSubCategory = (subCategory) => ({
  type: actionTypes.SET_CURRENT_SUBCATEGORY,
  payload: subCategory
})
